
export async function useGsap() {

  const { default: gsap } = await import('gsap')
  const TextPlugin = await import('gsap/TextPlugin')
  const ScrollTrigger = await import('gsap/ScrollTrigger')

  gsap.registerPlugin(TextPlugin)
  gsap.registerPlugin(ScrollTrigger)

  return gsap
}